import { JSX } from 'react';
import { TextField, InputAdornment } from '@mui/material';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export default function PercentageInput({
  value,
  onChange,
}: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ inputMode: 'numeric', 'data-testid': 'percentage-input' }}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
